angular.module('NumbersEditor').controller('GameController', [
    '$scope', '$routeParams', 'GameFactory', '$location', '$rootScope', '$filter', 'NewGameFactory', 'EventFactory', 'PublishGameFactory', '$dialogs', 'authFactory', '$route', 'gameService',
    function ($scope, $routeParams, gameFactory, $location, $rootScope, $filter, newGameFactory, eventFactory, publishGameFactory, $dialogs, authFactory, $route, gameService) {

        function getGame(gameId, sportCode, startDate) {
            gameService.getGame(gameId, sportCode, startDate)
                .then(function (game) {
                    $scope.Game = game;
                    console.log(game);
                })
                .catch(function (error) {
                    $.message(error.ExceptionMessage, MessageType.Error);
                });
        };

        function convertUtcDateToLocalDate(date) {
            var newDate = new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);

            var offset = date.getTimezoneOffset() / 60;
            var hours = date.getHours();

            newDate.setHours(hours - offset);

            return newDate;
        };

        function hasLunchTimeDrawCompletedFor49S(id, number) {
            if ($routeParams.sportCode === "49" && number === 2) { // user trying to access tea time draw for 49.
                // Lunch time draw must be completed
                var lunchTimeDrawStatus = $scope.Game.Events[0].Status;
                if (lunchTimeDrawStatus === "A" || lunchTimeDrawStatus === "P" || lunchTimeDrawStatus === "O" || lunchTimeDrawStatus === "X")
                    return false; // Active / Pending Changes/ Offed/ Resulted but not yet publish
            }
            return true;
        }

        function init() {
            $rootScope.SetAppTitle("Game", "Manage Game");
            $scope.isAdmin = authFactory.GetAuthenticationData().isAdmin;
            $scope.isTechSuper = authFactory.GetAuthenticationData().isTechSuper;
            getGame($routeParams.gameId, $routeParams.sportCode, $routeParams.startDate);
            localStorage.setItem("GameId", $routeParams.gameId);
            localStorage.setItem("sportCode", $routeParams.sportCode);
        };

        init();

        $scope.PublishGame = function () {
            gameService.publishGame($routeParams.gameId)
                .success(function (game) {
                    $.message(MessageText.GameSuccessfullyPublished, MessageType.Success);
                    $scope.Game = game;
                })
                .error(function (error) {
                    $.message(error.ExceptionMessage, MessageType.Error);
                });
        };
        $scope.IsPublished = function () {
            if ($scope.Game == null) return false;
            return !($scope.Game.PublicationStamp == null);
        };

        $scope.CancelGame = function () {
            var dlg = $dialogs.confirm('Please Confirm', 'Are you sure you want to cancel this game?');
            dlg.result.then(function (btn) {
                gameFactory.CancelGame($routeParams.gameId)
                    .success(function (game) {
                        $scope.Game = game;
                        $.message(MessageText.GameSuccessfullyCancelled, MessageType.Success);
                    })
                    .error(function (error) {
                        $.message(error.ExceptionMessage, MessageType.Error);
                    });
            });

        };
        $scope.CanCancelGame = function () {
            if ($scope.Game == null) return false;

            var activeEvents = Enumerable.From($scope.Game.Events)
                .Where(function (x) { return x.Status == "A"; })
                .Count();

            if ($scope.Game.Status == "O" && $scope.Game.Events.length == activeEvents) return true;
            return false;
        };

        $scope.UnCancelGame = function () {
            gameFactory.UnCancelGame($routeParams.gameId)
                .success(function (game) {
                    $scope.Game = game;
                    $.message(MessageText.GameSuccessfullyUnCancelled, MessageType.Success);
                })
                .error(function (error) {
                    $.message(error.ExceptionMessage, MessageType.Error);
                });
        };
        $scope.CanUnCancelGame = function () {
            if ($scope.Game == null) return false;
            if ($scope.Game.Status === "C") return true;
            return false;
        };

        $scope.VoidGame = function () {
            var dlg = $dialogs.confirm('Please Confirm', 'Are you sure you want to void this game?');
            dlg.result.then(function (btn) {
                gameFactory.VoidGame($routeParams.gameId)
                    .success(function (game) {
                        $scope.Game = game;
                        $.message(MessageText.GameSuccessfullyVoided, MessageType.Success);
                    })
                    .error(function (error) {
                        $.message(error.ExceptionMessage, MessageType.Error);
                    });
            });
        };
        $scope.CanVoidGame = function () {

            if ($scope.Game == null) return false;
            if ($scope.isAdmin === false) return false;

            var eventCount = $scope.Game.Events.length;
            var suspendedEventCount = Enumerable.From($scope.Game.Events)
                .Where(function (x) { return x.Status === "S"; })
                .Count();
            var changePendingEventCount = Enumerable.From($scope.Game.Events)
                .Where(function (x) { return x.Status === "P"; })
                .Count();

            if (eventCount === suspendedEventCount || eventCount === changePendingEventCount)
                return true;

            return false;
        };

        $scope.CanEditGame = function () {
            if ($scope.Game == null) return false;
            if ($scope.isAdmin === false) return false;
            return !$scope.IsPublished();
        };

        $scope.DeleteGame = function () {
            var dlg = $dialogs.confirm('Please Confirm', 'Are you sure you want to delete this game?');
            dlg.result.then(function (btn) {
                gameFactory.DeleteGame($routeParams.gameId)
                    .success(function () {
                        $.message(MessageText.GameSuccessfullyDeleted, MessageType.Success);
                        $location.path('/');
                    })
                    .error(function (error) {
                        $.message(error.ExceptionMessage, MessageType.Error);
                    });
            });
        };

        $scope.EditGame = function () {
            $location.path("gameedit/" + $routeParams.gameId).search({ sportCode: $routeParams.sportCode, startDate: $routeParams.startDate });
        };

        $scope.AddEvent = function () {
            var newEvent = newGameFactory.AddEvent($scope.Game.Events.length);
            $scope.Game.Events.push(newEvent);
        };
        $scope.DeleteEvent = function (index, id) {
            var dlg = $dialogs.confirm('Please Confirm', 'Are you sure you want to delete this event?');
            dlg.result.then(function (btn) {
                if (id == 0) {
                    $scope.Game.Events.splice(index, 1);
                } else {
                    eventFactory.Delete(id)
                        .success(function (success) {
                            $route.reload();
                            $.message(MessageText.EventSuccessfullyDeleted, MessageType.Success);
                        })
                        .error(function (error) {
                            $.message(error.ExceptionMessage, MessageType.Error);
                        });
                }
            });
        };
        $scope.SaveEvent = function (eventTime) {
            var eTime = new Date(1970, 0, 1);
            eTime.setHours(eventTime.split(":")[0]);
            eTime.setMinutes(eventTime.split(":")[1]);
            eTime.setSeconds("00");
            var x = convertUtcDateToLocalDate(eTime);

            var eventDtoAdd = { RefId: $routeParams.gameId, EventTime: x.getTime() };
            eventFactory.Save(eventDtoAdd)
                .success(function (game) {
                    $route.reload();
                    //$scope.Game = game;
                    $.message(MessageText.EventSuccessfullySaved, MessageType.Success);
                })
                .error(function (error) {
                    $.message(error.ExceptionMessage, MessageType.Error);
                });
        };
        $scope.UpdateEvent = function (eventId, eventTime) {
            var eTime = new Date(1970, 0, 1);
            eTime.setHours(eventTime.split(":")[0]);
            eTime.setMinutes(eventTime.split(":")[1]);
            eTime.setSeconds("00");
            var x = convertUtcDateToLocalDate(eTime);

            var eventDtoAdd = { RefId: eventId, EventTime: x.getTime() };
            eventFactory.Update(eventId, eventDtoAdd)
                .success(function (game) {
                    $.message(MessageText.EventSuccessfullySaved, MessageType.Success);
                })
                .error(function (error) {
                    $.message(error.ExceptionMessage, MessageType.Error);
                });
        };
        $scope.SaveGame = function () {
            gameService.saveGame($scope.Game)
                .success(function (gameId) {
                    $location.path("game/" + gameId).search({ sportCode: $routeParams.sportCode, startDate: $routeParams.startDate });
                    $.message(MessageText.GameSuccessfullySaved, MessageType.Success);
                })
                .error(function (ex) {
                    $.message(ex.ExceptionMessage, MessageType.Error);
                });
        };

        $scope.PublishResult = function () {
            var dialog;

            gameFactory.TwoDrawApprovedButtons()
                .success(function (result) {
                    if ($scope.Game.SportCode === "49" && JSON.parse(result)) {
                        dialog = $dialogs.DrawApproval();
                    } else {
                        dialog = $dialogs.confirm('Please Confirm', "Are you sure you want to publish the results?");
                    }

                    dialog.result.then(function (btn) {
                        gameFactory.PublishResult($routeParams.gameId)
                            .success(function (game) {
                                $.message(MessageText.ResultSuccessfullyPublished, MessageType.Success);
                                $scope.Game = game;
                            })
                            .error(function (error) {
                                $.message(error.ExceptionMessage, MessageType.Error);
                            });
                    });
                })
                .error(function (error) {
                    $.message(error.ExceptionMessage, MessageType.Error);
                });
        };
        $scope.CanPublishResult = function () {
            if ($scope.Game == null) return false;

            var preResulted = Enumerable.From($scope.Game.Events)
                .Any(function (x) { return x.Status == "X" || x.Status == "P"; });
            return preResulted;

        };


        $scope.go = function (view, id, number) {
            eventFactory.CanAccessTheEvent(id)
                .success(function (result) {
                    if (result === "true") {
                        $location.path(view + '/' + id).search({ sportCode: $routeParams.sportCode, startDate: $routeParams.startDate, no: number });
                    } else {
                        $.message("You must complete the lunch time draw in order to access the tea time draw. Please contact admin for more details", MessageType.Info);
                    }
                })
                .error(function (error) {
                    $.message("You can't access the draw at the moment. Check your internet connection and please refresh the page.", MessageType.Error);
                });
        };

        $scope.DisplayPublishResultButton = function () {
            if ($scope.IsPublished() && $.IsStepByStepOn() === false) return true;
            else return false;
        }
    }
]);